import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
} from "axios";
import { errorMessage } from "./notificationUtils";
import { store } from "../store/store";
import { broadcastBillAuditLogout } from "./billAuditSession";

const Axios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT || "",
});

// Add an interceptor for requests
Axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = store.getState().auth.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Add an interceptor for responses
Axios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const skipSessionRedirect = error.config?.skipSessionRedirect;
    if (
      !skipSessionRedirect &&
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      errorMessage("Session Expired.");
      broadcastBillAuditLogout();
      localStorage.removeItem("edgeProAccessToken");
      localStorage.removeItem("edgeProRefreshToken");
      localStorage.removeItem("userName");
      localStorage.removeItem("persist:root");
      window.location.href = `${window.location.origin}/login`;
    } else if (
      error.code === "ERR_NETWORK" &&
      !window.location.pathname.includes("/dashboard")
    ) {
      errorMessage("Failed to connect to the server. Please try again later.");
    }
    return Promise.reject(error);
  }
);

export default Axios;
